var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"downFooter"},[_c('div',{staticClass:"code"},[_c('img',{attrs:{"src":require("@/assets/pingxuan2022/pc/images/wechart-subscription.png"),"alt":""}})]),_c('div',{staticClass:"codeFont"},[_c('p',[_vm._v(" 扫码关注 "),_c('br'),_vm._v("极果微信订阅号 ")])])])
}]

export { render, staticRenderFns }